// extracted by mini-css-extract-plugin
export var activeDot = "_9n-c";
export var buttonContainer = "_9n-9";
export var channelButton = "_9n-a";
export var clickable = "_9n-d";
export var content = "_9n-0";
export var contentFull = "_9n-2";
export var contentThird = "_9n-1";
export var contentWrapper = "_9n-7";
export var description = "_9n-5";
export var heightShort = "_9n-f";
export var image = "_9n-3";
export var imageContainer = "_9n-4";
export var selectButton = "_9n-e";
export var spinnerContainer = "_9n-b";
export var titleContent = "_9n-8";
export var titleWrapper = "_9n-6";